import { usePaymentContext } from "components/PaymentContextProvider";
import { Helmet } from "react-helmet";

const Metatags = () => {
  const { shoutout } = usePaymentContext();
  const {
    introduction,
    artistGroupName,
    assets: {
      icon: { path: shoutoutImageUrl },
    },
  } = shoutout;

  return (
    <Helmet>
      <title>ShoutOuts - {artistGroupName}</title>
      <meta name="title" content={`ShoutOuts - ${artistGroupName}`} />
      <meta name="description" content={introduction} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:title" content={`ShoutOuts - ${artistGroupName}`} />
      <meta property="og:description" content={introduction} />
      <meta property="og:image" content={shoutoutImageUrl} />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={window.location.href} />
      <meta
        property="twitter:title"
        content={`ShoutOuts - ${artistGroupName}`}
      />
      <meta property="twitter:description" content={introduction} />
      <meta property="twitter:image" content={shoutoutImageUrl} />
    </Helmet>
  );
};

export default Metatags;
